import TableLayout from "../../../shared/table/table-layout";
import CampaignTable from "../../../shared/campaign/all-campaign/all-campaign-table";
import CampaignMetricCards from "../../../shared/campaign/all-campaign/matric-cards";
import { useCampaignsReport } from "../../../../hooks/use-reports";
import CampaignReportTable from "../../../shared/campaign/reports/all-campaign-reports-table";

const pageHeader = {
  title: "All Campaigns Reports",
  breadcrumb: [],
};

export default function AllReports() {
  const { data, isLoading, error } = useCampaignsReport();
  console.log(data,"data")
  return (
    <div className="flex flex-col gap-20 @container 2xl:gap-x-6 2xl:gap-y-7 3xl:gap-8">
      <div className="flex flex-col gap-5 @container 2xl:gap-x-6 2xl:gap-y-7 3xl:gap-8">
      
      </div>
      <div className="@container">
        <TableLayout
          title={pageHeader.title}
          breadcrumb={pageHeader.breadcrumb}
          // data={campaigns}
          fileName="all_campaigns_data"
          header="ID,Name,Username,Avatar,Email,Due Date,Amount,Status,Created At"
        >
          <CampaignReportTable
            campaigns={data || []}
            isLoading={isLoading}
            error={error}
          />
        </TableLayout>
      </div>
    </div>
  );
}
